import { ethers } from 'ethers';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var ADDRESS = '0x00000000000076a84fef008cdabe6409d2fe638b';
var ABI = [
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: 'address', name: 'vault', type: 'address' },
            { indexed: false, internalType: 'address', name: 'delegate', type: 'address' },
            { indexed: false, internalType: 'bool', name: 'value', type: 'bool' },
        ],
        name: 'DelegateForAll',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: 'address', name: 'vault', type: 'address' },
            { indexed: false, internalType: 'address', name: 'delegate', type: 'address' },
            { indexed: false, internalType: 'address', name: 'contract_', type: 'address' },
            { indexed: false, internalType: 'bool', name: 'value', type: 'bool' },
        ],
        name: 'DelegateForContract',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: 'address', name: 'vault', type: 'address' },
            { indexed: false, internalType: 'address', name: 'delegate', type: 'address' },
            { indexed: false, internalType: 'address', name: 'contract_', type: 'address' },
            { indexed: false, internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { indexed: false, internalType: 'bool', name: 'value', type: 'bool' },
        ],
        name: 'DelegateForToken',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{ indexed: false, internalType: 'address', name: 'vault', type: 'address' }],
        name: 'RevokeAllDelegates',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: 'address', name: 'vault', type: 'address' },
            { indexed: false, internalType: 'address', name: 'delegate', type: 'address' },
        ],
        name: 'RevokeDelegate',
        type: 'event',
    },
    {
        inputs: [
            { internalType: 'address', name: 'delegate', type: 'address' },
            { internalType: 'address', name: 'vault', type: 'address' },
        ],
        name: 'checkDelegateForAll',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'delegate', type: 'address' },
            { internalType: 'address', name: 'vault', type: 'address' },
            { internalType: 'address', name: 'contract_', type: 'address' },
        ],
        name: 'checkDelegateForContract',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'delegate', type: 'address' },
            { internalType: 'address', name: 'vault', type: 'address' },
            { internalType: 'address', name: 'contract_', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'checkDelegateForToken',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'delegate', type: 'address' },
            { internalType: 'bool', name: 'value', type: 'bool' },
        ],
        name: 'delegateForAll',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'delegate', type: 'address' },
            { internalType: 'address', name: 'contract_', type: 'address' },
            { internalType: 'bool', name: 'value', type: 'bool' },
        ],
        name: 'delegateForContract',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'delegate', type: 'address' },
            { internalType: 'address', name: 'contract_', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { internalType: 'bool', name: 'value', type: 'bool' },
        ],
        name: 'delegateForToken',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'vault', type: 'address' }],
        name: 'getContractLevelDelegations',
        outputs: [
            {
                components: [
                    { internalType: 'address', name: 'contract_', type: 'address' },
                    { internalType: 'address', name: 'delegate', type: 'address' },
                ],
                internalType: 'struct IDelegationRegistry.ContractDelegation[]',
                name: 'contractDelegations',
                type: 'tuple[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'vault', type: 'address' }],
        name: 'getDelegatesForAll',
        outputs: [{ internalType: 'address[]', name: 'delegates', type: 'address[]' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'vault', type: 'address' },
            { internalType: 'address', name: 'contract_', type: 'address' },
        ],
        name: 'getDelegatesForContract',
        outputs: [{ internalType: 'address[]', name: 'delegates', type: 'address[]' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'vault', type: 'address' },
            { internalType: 'address', name: 'contract_', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'getDelegatesForToken',
        outputs: [{ internalType: 'address[]', name: 'delegates', type: 'address[]' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'delegate', type: 'address' }],
        name: 'getDelegationsByDelegate',
        outputs: [
            {
                components: [
                    { internalType: 'enum IDelegationRegistry.DelegationType', name: 'type_', type: 'uint8' },
                    { internalType: 'address', name: 'vault', type: 'address' },
                    { internalType: 'address', name: 'delegate', type: 'address' },
                    { internalType: 'address', name: 'contract_', type: 'address' },
                    { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
                ],
                internalType: 'struct IDelegationRegistry.DelegationInfo[]',
                name: 'info',
                type: 'tuple[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'vault', type: 'address' }],
        name: 'getTokenLevelDelegations',
        outputs: [
            {
                components: [
                    { internalType: 'address', name: 'contract_', type: 'address' },
                    { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
                    { internalType: 'address', name: 'delegate', type: 'address' },
                ],
                internalType: 'struct IDelegationRegistry.TokenDelegation[]',
                name: 'tokenDelegations',
                type: 'tuple[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    { inputs: [], name: 'revokeAllDelegates', outputs: [], stateMutability: 'nonpayable', type: 'function' },
    {
        inputs: [{ internalType: 'address', name: 'delegate', type: 'address' }],
        name: 'revokeDelegate',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'vault', type: 'address' }],
        name: 'revokeSelf',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
        name: 'supportsInterface',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
];

var getDelegationType = function (key) {
    var types = ['NONE', 'ALL', 'CONTRACT', 'TOKEN'];
    return types[key] || 'NONE';
};
var getDefaultProvider = function () {
    var _a;
    if (typeof process !== 'undefined' && ((_a = process.env) === null || _a === void 0 ? void 0 : _a.PROVIDER_URL))
        return new ethers.providers.JsonRpcProvider(process.env.PROVIDER_URL);
    // @ts-ignore
    if (typeof window !== 'undefined' && window.ethereum) {
        // @ts-ignore
        return new ethers.providers.Web3Provider(window.ethereum);
    }
    return null;
};

var delegationInterface = new ethers.utils.Interface(ABI);
function getSigner(provider) {
    try {
        return provider.getSigner();
    }
    catch (_a) {
        return null;
    }
}
var DelegateCash = /** @class */ (function () {
    function class_1(provider) {
        if (provider === void 0) { provider = null; }
        var _this = this;
        // READS
        this.checkDelegateForAll = function (delegate, vault) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.callStatic.checkDelegateForAll(delegate, vault)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.checkDelegateForContract = function (delegate, vault, contract) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.callStatic.checkDelegateForContract(delegate, vault, contract)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.checkDelegateForToken = function (delegate, vault, contract, tokenId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.callStatic.checkDelegateForToken(delegate, vault, contract, tokenId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.getContractLevelDelegations = function (vault) { return __awaiter(_this, void 0, void 0, function () {
            var delegations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.callStatic.getContractLevelDelegations(vault)];
                    case 1:
                        delegations = _a.sent();
                        return [2 /*return*/, delegations.map(function (d) {
                                return {
                                    contract: d[0],
                                    delegate: d[1],
                                };
                            })];
                }
            });
        }); };
        this.getDelegatesForAll = function (vault) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.callStatic.getDelegatesForAll(vault)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.getDelegatesForContract = function (vault, contract) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.callStatic.getDelegatesForContract(vault, contract)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.getDelegatesForToken = function (vault, contract, tokenId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.callStatic.getDelegatesForToken(vault, contract, tokenId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.getDelegationsByDelegate = function (delegate) { return __awaiter(_this, void 0, void 0, function () {
            var delegations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.callStatic.getDelegationsByDelegate(delegate)];
                    case 1:
                        delegations = _a.sent();
                        return [2 /*return*/, delegations.map(function (d) {
                                return {
                                    type: getDelegationType(d[0]),
                                    vault: d[1],
                                    delegate: d[2],
                                    contract: d[3],
                                    tokenId: Number(d[4]),
                                };
                            })];
                }
            });
        }); };
        this.getTokenLevelDelegations = function (vault) { return __awaiter(_this, void 0, void 0, function () {
            var delegations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.callStatic.getTokenLevelDelegations(vault)];
                    case 1:
                        delegations = _a.sent();
                        return [2 /*return*/, delegations.map(function (d) {
                                return {
                                    contract: d[0],
                                    tokenId: Number(d[1]),
                                    delegate: d[2],
                                };
                            })];
                }
            });
        }); };
        //////
        // WRITES
        this.delegateForAll = function (delegate, value) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.connect(this.signer).delegateForAll(delegate, value)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.delegateForContract = function (delegate, contract, value) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.connect(this.signer).delegateForContract(delegate, contract, value)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.delegateForToken = function (delegate, contract, tokenId, value) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.connect(this.signer).delegateForToken(delegate, contract, tokenId, value)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.revokeAllDelegates = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.connect(this.signer).revokeAllDelegates()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.revokeDelegate = function (delegate) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.connect(this.signer).revokeDelegate(delegate)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.revokeSelf = function (vault) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delegationContract.connect(this.signer).revokeSelf(vault)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.provider = getDefaultProvider();
        this.signer = null;
        if (provider) {
            this.provider = provider;
            this.signer = getSigner(provider);
        }
        this.delegationContract = new ethers.Contract(ADDRESS, ABI, this.provider);
    }
    return class_1;
}());
var rawDelegateForAll = function (delegate, value) {
    return delegationInterface.encodeFunctionData('delegateForAll', [delegate, value]);
};
var rawDelegateForContract = function (delegate, contract, value) {
    return delegationInterface.encodeFunctionData('delegateForContract', [delegate, contract, value]);
};
var rawDelegateForToken = function (delegate, contract, tokenId, value) {
    return delegationInterface.encodeFunctionData('delegateForToken', [delegate, contract, tokenId, value]);
};
var rawRevokeAllDelegates = function () {
    return delegationInterface.encodeFunctionData('revokeAllDelegates');
};
var rawRevokeDelegate = function (delegate) {
    return delegationInterface.encodeFunctionData('revokeDelegate', [delegate]);
};

export { DelegateCash, rawDelegateForAll, rawDelegateForContract, rawDelegateForToken, rawRevokeAllDelegates, rawRevokeDelegate };
